var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 81,
    viewBox: "0 0 68 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_1626)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 81,
    rx: 10,
    fill: "#1CB0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 73.9125C0 69.9981 3.17318 66.825 7.0875 66.825H68V70.9999C68 76.5228 63.5228 81 58 81H7.0875C3.17318 81 0 77.8268 0 73.9125Z",
    fill: "#1894CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43994 73.9125C5.43994 71.8621 7.10208 70.2 9.15244 70.2H64.5999C64.5999 74.3007 61.2757 77.625 57.1749 77.625H9.15244C7.10208 77.625 5.43994 75.9628 5.43994 73.9125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.52,
    y: 60.075,
    width: 7.48,
    height: 6.75,
    fill: "#1894CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1201 56.0249H68.0001V56.8249C68.0001 62.3477 63.523 66.8249 58.0001 66.8249H57.1201V56.0249Z",
    fill: "#1CB0F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.8398,
    y: 67.5,
    width: 4.76,
    height: 3.375,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1999 70.2H9.17994C7.1144 70.2 5.43994 71.8621 5.43994 73.9125C5.43994 75.9628 7.1144 77.625 9.17994 77.625H10.1999V70.2Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6 70.875V70.2H9.52002V72.9H64.2887C64.491 72.2607 64.6 71.5805 64.6 70.875Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1201 66.825V70.2H61.2001C63.7171 70.2 65.9146 68.8425 67.0904 66.825H57.1201Z",
    fill: "#1894CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_1626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 81,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathBook);
export default __webpack_public_path__ + "static/media/path-book.2e6f8b6410673e2da67618e058beb399.svg";
export { ForwardRef as ReactComponent };